/**
 * CARTO Voyager vector style. Raster PNG tiles are being retired and now watermark
 * requests that omit an API key.
 * https://docs.carto.com/faqs/carto-basemaps
 */
export const CARTO_VOYAGER_GL_STYLE =
  'https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json';

export const CARTO_BASEMAP_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions" target="_blank" rel="noopener noreferrer">CARTO</a>';

export function getCartoBasemapStyleUrl(apiKey: string): string {
  if (!apiKey) {
    return CARTO_VOYAGER_GL_STYLE;
  }
  const url = new URL(CARTO_VOYAGER_GL_STYLE);
  url.searchParams.set('key', apiKey);
  return url.toString();
}

export function readCartoBasemapApiKey(): string {
  const fromDefine =
    typeof __CARTO_BASEMAPS_API_KEY__ !== 'undefined' ? __CARTO_BASEMAPS_API_KEY__ : '';
  return String(fromDefine).trim();
}
